export default [
  {
    path: '/saida/',
    name: 'saida',
    title: 'saida',
    component: () => import('../view/SaidaView.vue'),
    redirect: { name: 'saida-cadastrar' },
    children: [
      {
        path: 'welcome',
        name: 'saida-listar',
        component: () => import('../view/SaidaWelcomeView.vue'),
        meta: {
          title: 'Saída',
        },
      },
      {
        path: 'add',
        name: 'saida-cadastrar',
        meta: {
          title: 'Saída cadastrar',
        },
        component: () => import('../view/SaidaFormView.vue'),
      },
      {
        path: ':id',
        name: 'saida-editar',
        meta: {
          title: 'Saída editar',
        },
        component: () => import('../view/SaidaFormView.vue'),
      },
    ],
  },
];
